import React from "react";
import Proptypes from "prop-types";

const Ul = ({ items }) => {
    return (
        <ul className="unordered-list">
            {items.map((content, index) => (
                <li key={`list-item-${index}`} className="unordered-list__item">
                    <span className="fs-body1 c-gs-medium-em">{content}</span>
                </li>
            ))}
        </ul>
    );
};

Ul.propTypes = {
    items: Proptypes.arrayOf(Proptypes.string),
};

export default Ul;
